import environmentsSlice from './slice'

// eslint-disable-next-line import/prefer-default-export
export const environmentsActions = environmentsSlice.actions
